import axios from "axios";

const API_BASE_URL = "https://api.donatepe.org";
console.log("🔗 API Base URL:", API_BASE_URL);

// Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request logging
api.interceptors.request.use(
  (config) => {
    console.log("📤 API Request:", {
      url: config.url,
      method: config.method,
    });
    return config;
  },
  (error) => Promise.reject(error)
);

// Response logging
api.interceptors.response.use(
  (response) => {
    console.log("📥 API Response:", {
      url: response.config.url,
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error) => {
    console.error("❌ API Error:", {
      url: error.config?.url,
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
);

// ===== Fundraiser APIs (Clean Version) =====

// 1️⃣ Save/Update Fundraiser Basic Info
export const saveFundraiserBasic = async (data) => {
  try {
    const payload = {
      title: data.title,
      goalAmount: parseInt(data.goalAmount.replace(/\D/g, "") || "0"),
      purpose: data.purpose || "medical",
      // NEW: Include OTP verification fields
      otpTxnId: data.otpTxnId,  // OTP transaction ID from registration
      otp: data.otp,            // User's entered 6-digit OTP
      basic: {
        relation: data.patientRelation,
        education: data.education,
        employment: data.employmentStatus,
        ref_source: data.heardAbout,
      },
    };

    console.log("📤 Sending to /fundraisers/basic:", {
      ...payload,
      otp: '***' + payload.otp?.slice(-2) // Mask OTP in logs for security
    });

    const response = await api.post("/fundraisers/basic", payload);
    return response.data;
  } catch (error) {
    console.error("❌ saveFundraiserBasic error:", error.response?.data || error.message);
    throw error.response?.data || { message: error.message };
  }
};

// 2️⃣ Save/Update Patient Details
export const savePatientDetails = async (fundraiserId, data) => {
  try {
    const payload = {
      patientName: data.patientName,
      age: parseInt(data.patientAge),
      condition: data.medicalCondition,
      hospital: data.hospital,
      city: data.city,
      hospitalStatus: data.hospitalizationStatus,
    };

    const response = await api.post(`/fundraisers/${fundraiserId}/patient`, payload);
    return response.data;
  } catch (error) {
    console.error("❌ savePatientDetails error:", error.response?.data || error.message);
    throw error.response?.data || { message: error.message };
  }
};

// 3️⃣ Auto-generate Story (optional)
export const generateStory = async (fundraiserId) => {
  try {
    const response = await api.post(`/fundraisers/${fundraiserId}/auto-story`);
    return response.data;
  } catch (error) {
    console.error("❌ generateStory error:", error.response?.data || error.message);
    throw error.response?.data || { message: error.message };
  }
};

// 4️⃣ Submit Story (Final Step)
export const submitStory = async (fundraiserId, storyData) => {
  try {
    const payload = {
      title: storyData.title,
      storyHtml: storyData.storyHtml,
      add_documents: storyData.add_documents || storyData.addDocuments,
      consent_insurance: storyData.consent_insurance !== undefined ? storyData.consent_insurance : storyData.consentInsurance,
      agree_terms: storyData.agree_terms || storyData.agreeTerms,
    };

    const response = await api.post(`/fundraisers/${fundraiserId}/story`, payload);
    console.log("✅ Story submitted:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ submitStory error:", error.response?.data || error.message);
    throw error.response?.data || { message: error.message };
  }
};

export default {
  saveFundraiserBasic,
  savePatientDetails,
  generateStory,
  submitStory,
};